import { ExpandMore } from "@mui/icons-material";
import Accordion from "@mui/material/Accordion";
import { SyntheticEvent } from "react";
import { useFormContext } from "react-hook-form";
import AccordionDetails from "@mui/material/AccordionDetails";
import { useRecoilValue } from "recoil";
import { useTranslation } from "react-i18next";
import AccordionSummary from "@mui/material/AccordionSummary";
import { CBCreationOfProps, IFormValues } from "../../types";
import { isGlobalEditModeState } from "../../state/customerbaseState";
import UpdateBtnsAccordion from "../UpdateBtnsAccordion";
import CBPayment from "./CBPayment";

interface CBPaymentAccordionProps extends CBCreationOfProps {
    index: number,
    isExpanded: boolean,
    onRemove: (event: SyntheticEvent, index: number) => void
}

const CBPaymentAccordion = ({
    creationOf,
    index,
    isExpanded,
    onRemove
}: CBPaymentAccordionProps) => {

    const { t } = useTranslation('customerbase');
    const { getValues}  = useFormContext<IFormValues>();
    
    const isCreationMode = !!creationOf;

    const editing = useRecoilValue(isGlobalEditModeState);
    
    return (
        <Accordion>
            <AccordionSummary expandIcon={ <ExpandMore/> }>
                <UpdateBtnsAccordion
                    label={isCreationMode ? 
                        t("tabs.accordionsLabels.cbNewPayment") + (index == 0? "" : (" " + (index + 1))) :
                        t("tabs.accordionsLabels.cbPaymentInfoDetails") + (index == 0? "" : (" " + (index + 1)))
                    }
                    editing={editing}
                    isExpanded={isExpanded}
                    showRemove={(!getValues(`cbPaymentInfo.${index}.id`)) && (isCreationMode || editing)}
                    onRemove={(event) => onRemove(event, index)}
                />
            </AccordionSummary>
            <AccordionDetails>
                <CBPayment 
                    index={index}
                    creationOf={creationOf}
                />
            </AccordionDetails>
        </Accordion>
    )

}

export default CBPaymentAccordion;